import { connect, ConnectedProps } from 'react-redux'

import TopLevelAccordion from 'components/accordion/TopLevelAccordion'
import { setAccordionIsLoaded, setUserRolesModalIsOpen } from 'redux/actions'
import { AppDispatch, RootState } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  group: state.accordion.group,
  eventCategory: state.accordion.eventCategory,
  expandedNodeId: state.accordion.expandedNodeId,
  highlight: state.accordion.highlight,
  canAccess: state.accordion.canAccess
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setAccordionIsLoaded: (isLoaded: boolean) => dispatch(setAccordionIsLoaded(isLoaded)),
  setUserRolesModalIsOpen: (isOpen: boolean) => dispatch(setUserRolesModalIsOpen(isOpen))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type TopLevelAccordionContainerProps = ConnectedProps<typeof connector>

export default connector(TopLevelAccordion)
